import React from 'react';
import PropTypes from 'prop-types';
import { Duplicate } from 'components/SvgIcons';
import { infoToast } from 'utils/toast';
import './styles.scss';

const CopyToClipboard = (props) => {
    const { color, value } = props;

    const copyValue = () => {
        const textField = document.createElement('textarea');

        textField.innerText = value;
        document.body.appendChild(textField);
        textField.select();
        document.execCommand('copy');
        textField.remove();

        infoToast('cfm_label_copied_ok', [`"${value}"`]);
    };

    return <Duplicate color={color} onClick={() => copyValue()} />;
};

CopyToClipboard.propTypes = {
    color: PropTypes.string,
    value: PropTypes.string.isRequired,
};

export default CopyToClipboard;
